module.exports = __webpack_public_path__ + "img/IMG_2248_L_WoodMatted_MockedUp.a43ba698.jpg";